import React from 'react';
import ProgrammePageRenderer from '../components/ProgrammePageRenderer';

const seatToken = {
  hero: { section_key: 'hero', section_type: 'hero', image: '/images/page-banners/preparatory.webp' },
  intro: {
    section_key: 'intro',
    section_type: 'intro',
    kicker: 'Preparatory Programme',
    title: 'From Curiosity to Capability',
    image: '/images/our-program/preparatory-1.webp',
    description:
      "The Preparatory Stage marks an important transition in a child's educational journey. Students begin to move from exploring concepts to explaining, analysing and applying what they understand.\n\nAt St. Andrews World School, Indirapuram, our Preparatory Programme bridges the joyful learning of the foundational years with the greater academic depth of the school's ICSE learning pathway.\n\nLanguage, mathematics, science and social understanding are strengthened through projects, experiments, technology, creative expression and real-world experiences.\n\nOur objective is not simply to teach more\u2014it is to help children understand more deeply.",
    extra: { chip_text: 'Classes: III to V | Ages: 8\u201311 Years', chip_icon: 'fa-book-open', highlight: 3 },
  },
  concepts_header: {
    section_key: 'concepts_header',
    section_type: 'header',
    kicker: 'Learning With Understanding',
    title: 'Concepts That Make Sense',
    description:
      'Learning prioritises understanding over memorisation. Mathematics develops through reasoning and problem-solving, science through observation and experimentation, and the humanities through inquiry, discussion and meaningful context.\n\nStudents learn not only to find an answer, but also to explain the thinking behind it.',
    extra: { bg: 'light' },
  },
  skills_header: {
    section_key: 'skills_header',
    section_type: 'header',
    kicker: 'What Children Learn',
    title: 'Skills That Grow With Every Child',
  },
  card_1: {
    section_key: 'card_1',
    section_type: 'card',
    icon: 'fa-comments',
    title: 'Communication and Confident Expression',
    description:
      'Literature, creative writing, presentations and classroom discussions strengthen reading comprehension, structured writing and confident communication. Students learn to organise their thoughts, articulate ideas clearly and appreciate different perspectives.',
  },
  card_2: {
    section_key: 'card_2',
    section_type: 'card',
    icon: 'fa-lightbulb',
    title: 'Inquiry, Innovation and Application',
    description:
      'Projects, experiments, educational visits and practical activities connect classroom concepts with everyday life. Age-appropriate exposure to coding, robotics, STEM and digital tools encourages students to design, test and improve their ideas. Creative activities further develop imagination, adaptability and original thinking.',
  },
  card_3: {
    section_key: 'card_3',
    section_type: 'card',
    icon: 'fa-users',
    title: 'Independence and Collaboration',
    description:
      'Students gradually learn to organise their materials, manage assignments, accept feedback and take responsibility for their progress. Collaborative activities simultaneously develop teamwork, leadership, empathy and respect for different viewpoints. Teachers provide thoughtful guidance while encouraging learners to think and work with increasing independence.',
  },
  next_stage: {
    section_key: 'next_stage',
    section_type: 'split',
    kicker: 'Preparing for Middle School',
    title: 'Ready for the Next Chapter',
    image: '/images/our-program/preparatory-2.webp',
    description:
      'By the end of Class V, students develop strong subject knowledge alongside essential competencies in comprehension, communication, logical reasoning, collaboration and responsible decision-making.\n\nThey leave the Preparatory Stage ready not only for a more advanced syllabus, but also for a more independent and purposeful approach to learning.\n\nAt St. Andrews World School, Indirapuram, students are empowered to question confidently, think critically and apply knowledge meaningfully.',
    extra: { bg: 'navy', gold_line: 'Because knowledge becomes powerful when children learn how to use it.' },
  },
  cta: {
    section_key: 'cta',
    section_type: 'cta',
    icon: 'fa-comment-dots',
    title: 'Beyond the Classroom. Ready for the World.',
    description: 'Discover the wonder of learning at the Preparatory Programme of St. Andrews World School, Indirapuram.',
    button_text: 'Explore Our Programmes',
    button_url: '/our-programmes',
    button2_text: 'Enquire for Admission',
    button2_url: '/admission',
  },
};

const DEFAULT_SECTIONS = [
  seatToken.hero,
  seatToken.intro,
  seatToken.concepts_header,
  seatToken.skills_header,
  seatToken.card_1,
  seatToken.card_2,
  seatToken.card_3,
  seatToken.next_stage,
  seatToken.cta,
];

const seo = {
  title: 'Preparatory Programme',
  description: 'From curiosity to capability — the Preparatory Programme (Classes III to V) at St. Andrews World School, Indirapuram.',
  keywords: 'Preparatory Programme, ICSE school Indirapuram, St Andrews World School, Classes III to V',
};

const PreparatoryProgrammePage = () => (
  <ProgrammePageRenderer pageKey="preparatory" defaults={DEFAULT_SECTIONS} seo={seo} />
);

export default PreparatoryProgrammePage;